import * as React from 'react';
const SvgChevronLeft = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='m8.836 10 3.562 3.561a.55.55 0 0 1 .177.383.53.53 0 0 1-.177.391.54.54 0 0 1-.388.181q-.205 0-.394-.188l-3.863-3.863a.8.8 0 0 1-.144-.22.6.6 0 0 1-.048-.249.64.64 0 0 1 .192-.46l3.863-3.863q.18-.18.39-.185.21-.003.392.177.18.181.18.388 0 .205-.18.387z'
            />
        </g>
    </svg>
);
export default SvgChevronLeft;
